import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { HldStages } from "types/hldJudge"

interface Feedback {
  feedbacks: {
    clarifying_requirements?: string
    class_diagram?: string
    schema_design?: string
  }
  hireStatus: string
}

interface MessageQueue {
  type: string
  message: string
}

interface HLDJudgeState {
  currentStage: HldStages
  problemDescription: string
  isUserSpeaking: boolean
  feedback: Feedback | null
  messageQueue: MessageQueue[]
}

const initialState: HLDJudgeState = {
  currentStage: HldStages.TestInstructions,
  problemDescription: "",
  feedback: null,
  isUserSpeaking: false,
  messageQueue: [],
}

const HLDJudgeSlice = createSlice({
  name: "hld-judge",
  initialState,
  reducers: {
    updateCurrentStage: (state, action: PayloadAction<HldStages>) => {
      state.currentStage = action.payload
    },
    setProblemDescription: (state, action: PayloadAction<string>) => {
      state.problemDescription = action.payload
    },
    setFeedback: (state, action: PayloadAction<Feedback>) => {
      state.feedback = action.payload
    },
    setIsUserSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isUserSpeaking = action.payload
    },
    setMessageQueue: (state, action: PayloadAction<MessageQueue[]>) => {
      state.messageQueue = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  updateCurrentStage,
  setFeedback,
  setIsUserSpeaking,
  setProblemDescription,
  setMessageQueue,
  resetState,
} = HLDJudgeSlice.actions
export default HLDJudgeSlice.reducer
